<template>
  <el-dialog
    :visible.sync="visible"
    width="560px"
    :before-close="handleClose"
    custom-class="confirm-report-dialog"
  >
    <template slot="title">
      <div class="dialog-title">
        <i class="el-icon-success" style="color: #52c41a; font-size: 20px; margin-right: 6px;"></i>
        <span>确认报表</span>
      </div>
    </template>

    <!-- 报表信息 -->
    <div class="report-info">
      <div class="info-row">
        <span class="info-label">报表名</span>
        <span class="info-value">{{ row.fileName || '--' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">结算日期</span>
        <span class="info-value">{{ formatSettleDate(row.settlementDate) }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">订单数</span>
        <span class="info-value">{{ row.orderCount || 0 }}单</span>
      </div>
      <div class="info-row">
        <span class="info-label">结算佣金金额</span>
        <span class="info-value red">¥{{ row.settlementAmount || 0 }}</span>
      </div>
    </div>

    <!-- 选项 -->
    <div class="confirm-options">
      <div
        :class="['option-card', { active: confirmType === 'CONFIRM' }]"
        @click="confirmType = 'CONFIRM'"
      >
        <el-radio label="CONFIRM" v-model="confirmType">
          <span class="option-title">
            <i class="el-icon-success" style="color: #52c41a;"></i>
            确认无误
          </span>
        </el-radio>
        <div class="option-desc">确认报表数据正确，可以进行打款</div>
      </div>
      <div
        :class="['option-card', { active: confirmType === 'DISPUTED' }]"
        @click="confirmType = 'DISPUTED'"
      >
        <el-radio label="DISPUTED" v-model="confirmType">
          <span class="option-title">
            <i class="el-icon-warning" style="color: #faad14;"></i>
            有异议
          </span>
        </el-radio>
        <div class="option-desc">数据有问题，需要财务核查</div>
      </div>
    </div>

    <!-- 异议原因 -->
    <div v-if="confirmType === 'DISPUTED'" class="reason-section">
      <el-input
        type="textarea"
        :rows="3"
        v-model="reason"
        placeholder="请填写异议订单号及原因，格式见下方提示语"
      ></el-input>
      <div class="reason-tip">
        <p>请按以下格式提供异议说明，否则会严重耽误核查和打款速度，格式：</p>
        <p>订单号：6924111703859428938</p>
        <p>订单异议原因：报单晚于确收/订单实际比例为多少</p>
      </div>
    </div>

    <template slot="footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">确认提交</el-button>
    </template>
  </el-dialog>
</template>

<script>
const dayjs = require('dayjs')

export default {
  name: 'ConfirmReportDialog',
  props: {
    value: { type: Boolean, default: false },
    row: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      confirmType: 'CONFIRM',
      reason: '',
      submitting: false
    }
  },
  computed: {
    visible: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          console.log('this.row:', this.row)
          this.confirmType = this.row.status || 'CONFIRM'
          this.reason = this.row.disputeReason || ''
        }
      },
      immediate: true
    }
  },
  methods: {
    formatSettleDate(date) {
      if (!date) return '--'
      return dayjs(date).format('YYYY年M月D日')
    },
    handleClose() {
      this.$emit('input', false)
      this.$emit('close')
    },
    handleSubmit() {
      if (this.confirmType === 'DISPUTED' && !this.reason.trim()) {
        this.$message.warning('请填写异议原因')
        return
      }
      this.submitting = true
      const params = {
        reportId: this.row.id,
        confirmType: this.confirmType,
        disputeReason: this.confirmType === 'DISPUTED' ? this.reason.trim() : ''
      }
      this.$http('post', 'mall/bdM2sSettlementReport/confirm', params).then(() => {
        this.$message.success('确认报表成功')
        this.$emit('on-success')
        this.handleClose()
      }).catch(() => {}).finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>

<style scoped>
.dialog-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}
.report-info {
  border: 1px solid #e8ecf2;
  border-radius: 6px;
  padding: 16px 20px;
  margin-bottom: 16px;
}
.info-row {
  display: flex;
  line-height: 32px;
}
.info-label {
  width: 90px;
  flex-shrink: 0;
  color: #999;
  font-size: 14px;
}
.info-value {
  color: #333;
  font-size: 14px;
  flex: 1;
}
.info-value.red {
  color: rgba(232, 0, 0, 1);
  font-weight: 600;
}
.confirm-options {
  margin-bottom: 16px;
}
.option-card {
  border: 1px solid #e8ecf2;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.2s;
}
.option-card.active {
  border-color: #1990FF;
  background: #f0f7ff;
}
.option-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}
.option-title i {
  margin-right: 4px;
}
.option-desc {
  font-size: 12px;
  color: #999;
  padding-left: 25px;
  margin-top: 2px;
}
.reason-section {
  margin-bottom: 8px;
}
.reason-section ::v-deep .el-textarea__inner {
  border-color: #dcdfe6;
}
.reason-tip {
  margin-top: 8px;
  font-size: 12px;
  color: rgba(232, 0, 0, 1);
  line-height: 20px;
}
.reason-tip p {
  margin: 0;
}
</style>
